/** 问卷分类在 categories.type 中的取值，与目录筛选一致 */
export const QUESTIONNAIRE_CATEGORY_TYPE = 'questionnaire';
